module.exports = __webpack_public_path__ + "img/kildare.9c0f26b0.jpg";